<div class="chart-container dashboard-gauge-chart not-printable">
  <canvas id="gauge-chart"></canvas>
  <div class="label-container">
    <div class="font-size-4">
      <span *ngIf="currentValue >= 0; else notAvailable">{{ currentValue }}%</span>
    </div>
    <div class="font-color-grey">{{ 'D14' | translate : locale }}</div>
    <div class="chart-footer">
      <div>{{ 'D13' | translate : locale }}</div>
      <div>{{ 'D15' | translate : locale }}</div>
    </div>
  </div>
</div>

<div class="chart-container dashboard-gauge-chart printable">
  <canvas id="gauge-chart-print"></canvas>
  <div class="label-container">
    <div class="font-size-4">{{ currentValue }}%</div>
    <div class="font-color-grey">{{ 'D14' | translate : locale }}</div>
    <div class="chart-footer">
      <div>{{ 'D13' | translate : locale }}</div>
      <div>{{ 'D15' | translate : locale }}</div>
    </div>
  </div>
</div>


<ng-template #notAvailable>{{ 'D10' | translate: locale }}</ng-template>